"use strict";
//SAMPLE COMPONENT: FOR USAGE OF LINE ITEM AUTOMATION SERVICE
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestLineItemAutomationComponent = void 0;
const core_1 = require("@angular/core");
const lineitem_automation_service_1 = require("./lineitem-automation.service");
const notification_service_1 = require("./notification.service");
const notifier_service_1 = require("./notifier.service");
const token_service_1 = require("./token.service");
let TestLineItemAutomationComponent = class TestLineItemAutomationComponent {
    constructor(_lineItemAutomation, _talk, _notifier, _http) {
        this._lineItemAutomation = _lineItemAutomation;
        this._talk = _talk;
        this._notifier = _notifier;
        this._http = _http;
        this.TEST_DFP_NETWORK_ID = 21670180311;
        this.TEST_LINE_ITEM_NAMING = "TEST hb_pb# is %s";
        this.TEST_AD_UNITS_MAPPING = ["TEST_AD_UNIT_626_5760af64-3243-448a-ac4a-878c7c362e7b", "TEST_AD_UNIT_626_9f94d8bf-b9d6-4595-8e14-49c1e9896212", "TEST_AD_UNIT_626_ec0233bd-43b9-4fb0-afdf-c17b0b30e80e"];
        this.TEST_COMPANY_IDS = [4484408615, 4484242989, 4491159494, 4493975514, 4494273065, 4499770004, 4499547576, 4505531278, 4505576357, 4505577269, 4506174611, 4484428502, 4484627727, 4486138055, 4485947733, 4485952299, 4485952740, 4485952929, 4487542710, 4482415652];
        this.data = null;
        this.error = null;
        this.eventPromptInProcess = false;
        this.lineItemAutomationCompleted = false;
        //private bidderIds:string = "1100,1101,1102,1103,1104,1105,1106,1107";
        this.pendingNotification = { bidder: null, user: 190, state: 'pending', dfpNetworkCode: this.TEST_DFP_NETWORK_ID };
        this.bidder = '1104';
        this.companyId = this.TEST_COMPANY_IDS[0];
        this.namingConventionIncrement = 1;
        this.bypassBidderStateVerification = false;
    }
    ngOnInit() {
        //Register the function that will receive the sockets events received from Python script
        this._lineItemAutomation.registerOnSocketEvent(this.onSocketEvent.bind(this));
    }
    startLineItemService(args, promptResponse) {
        let data = args;
        console.log(`Starting service for bidderID: ${data.bidder}`, args);
        //Add any prompt responses confirmations
        if (promptResponse)
            data.args.promptResponse = promptResponse;
        //Start service request
        this._lineItemAutomation.start(data);
        this.lineItemAutomationCompleted = false;
    }
    startRequest(type) {
        let bidderIds = this.getBidderIds();
        switch (type) {
            case 'single':
                let bidderData = this.generateBidderData(bidderIds[0], this.TEST_LINE_ITEM_NAMING.replace("#", this.namingConventionIncrement + ''));
                this.args = JSON.stringify(bidderData);
                this.verifyLineItemDfpConfig(bidderIds[0], bidderData.args.args[0])
                    .then((verifiedData) => {
                    this.startLineItemService(bidderData);
                });
                break;
            case 'multiple':
                bidderIds.forEach((bidder, idx) => {
                    let bidderData = this.generateBidderData(bidder, this.TEST_LINE_ITEM_NAMING.replace("#", `${idx}${this.namingConventionIncrement}`));
                    return this.verifyLineItemDfpConfig(bidder, bidderData.args.args[0])
                        .then((verifiedData) => {
                        this.startLineItemService(bidderData);
                    });
                });
                break;
            default:
                this._talk.broadcast('Invalid Request Type');
        }
    }
    getBidderIds() {
        if (this.bidder) {
            if (this.bidder.includes(',')) {
                return this.bidder.split(',').map((b) => parseInt(b.trim()));
            }
            return [parseInt(this.bidder)];
        }
    }
    generateBidderData(bidder, namingConv) {
        return {
            "script": 'wizard',
            bidder: bidder,
            bypassBidderStateVerification: this.bypassBidderStateVerification,
            //Publisher TSR123 Data
            "args": {
                "command": "main",
                "args": [
                    {
                        "dfpNetworkCode": this.TEST_DFP_NETWORK_ID,
                        "lineItemNamingConvention": namingConv,
                        "companyId": this.companyId,
                        "creativeIds": null, //[138216135388, 138216135640, 138216135643, 138216135910, 138216135646, 138216135397, 138216135400, 138216135913, 138216135652, 138216135655],
                        "inventoryTargeting": { 'mode': 'ron' },
                        "priceBucketConfig": [
                            {
                                "min": "0.01",
                                "value": "0.01"
                            },
                            {
                                "min": "3.00",
                                "value": "0.10"
                            },
                            {
                                "min": "6.00",
                                "value": "0.10"
                            }
                        ]
                    }
                ]
            }
        };
    }
    verifyLineItemDfpConfig(bidder, configValues) {
        return __awaiter(this, void 0, void 0, function* () {
            //Check if this bidder has bidder config created
            try {
                let values = yield this._lineItemAutomation.updateDfpConfigValues(bidder, configValues);
                console.log('Verified values for bidder', bidder, values);
                return values;
            }
            catch (err) {
                console.error('Unable to verify config values for bidder', bidder, err);
                return err;
            }
        });
    }
    //LINE ITEM AUTOMATION
    onSocketEvent(event) {
        if (event.status) {
            switch (event.status) {
                case 'prompt':
                    event.status = "confirmation required";
                    this.eventPromptInProcess = true;
                    let data = event.data;
                    let promptValues = event.values;
                    let eventPromptResponse = [];
                    //Notify the user for prompt
                    if (Array.isArray(promptValues)) {
                        let promptCount = 0;
                        promptValues.forEach((key, idx) => {
                            let response = {};
                            this._talk.confirm(`<div>
                                <h2> Please confirm to continue line item automation:</h2>
                                <div class="alert alert-info">
                                   <h3>${key.msg || `Would you like to ${key.name}?`}</h3> 
                                </div>
                                <p>Click "OK" to accept or "Cancel" to reject.</p>
                            </div>`).then(resultPromise => {
                                if (resultPromise.result)
                                    return resultPromise.result
                                        .then(result => {
                                        //User response Accepted
                                        response[key.name] = true;
                                        eventPromptResponse.push(response);
                                        promptCount++;
                                        if (promptCount === promptValues.length) {
                                            this.eventPromptInProcess = false;
                                            this.sendLineItemAutomationPromptResponse(data, eventPromptResponse);
                                        }
                                    });
                            }).catch(rejection => {
                                //User cancelled or closed modal, so response will be false
                                response[key.name] = false;
                                eventPromptResponse.push(response);
                                promptCount++;
                                if (promptCount === promptValues.length) {
                                    this.eventPromptInProcess = false;
                                    this.sendLineItemAutomationPromptResponse(data, eventPromptResponse);
                                }
                            });
                        });
                    }
                    break;
                case 'finished':
                    //Only finish, if there is no prompt confirmations in process
                    if (!this.eventPromptInProcess) {
                        //Stop notifications
                        if (!this.lineItemAutomationCompleted) { //Verify that we have not displayed those notifications previously on a different 'finished' event
                            this._notifier.close();
                            this._talk.broadcast('Line Item Automation Successfully Completed.');
                            this.lineItemAutomationCompleted = true;
                        }
                    }
                    else {
                        event.status = "promptInProcess";
                        event.message = "waiting for prompt confirmation";
                    }
                    break;
            }
            //Log current event state
            this.logLineAutomationEvent(event);
        }
        else {
            console.warn('Hmm..! No LineItemAutomation event status received.');
        }
    }
    sendLineItemAutomationPromptResponse(data, promptResponse) {
        if (promptResponse && (data && data === Object(data))) {
            // Send a request to start the script service with promptResponse include previews data
            let args = data;
            //Make sure we have the required args
            // args.priceBucketConfig = data.priceBucketConfig || this.priceBuckets; //TODO: We need to verify those buckets
            // args.dfpNetworkCode = data.dfpNetworkCode || this.getDfpNetworkCode();
            // args.lineItemNamingConvention = data.lineItemNamingConvention || this.getLineItemNamingConvention();
            //console.log('sending prompt response', args, promptResponse);
            this.logLineAutomationEvent({ status: 'sending prompt responses' });
            //Start a new service request with the prompt response values
            this.startLineItemService(args, promptResponse);
        }
    }
    logLineAutomationEvent(event) {
        let logStr = "line item automation";
        let notificationId = `LIA-${event.bidder}`;
        switch (event.status) {
            case 'running':
                event.status = `${logStr}: running`;
                this._notifier.start({ id: notificationId, title: 'Line Item Automation', status: event.status });
                break;
            case 'save':
                event.status = `save event`;
                //this._notifier.progress(`${logStr} processing save data.`, event.message);
                break;
            case 'data':
                if (event.data && event.data.progress) { //find any progress counts
                    let progressData = event.data.progress;
                    if (progressData && progressData === Object(progressData)) {
                        let total = 0;
                        let completed = 0;
                        let progressValues = "";
                        for (let progress in progressData) {
                            progressValues += `${progress}; `;
                            if (progressData[progress].total)
                                total += progressData[progress].total;
                            if (progressData[progress].completed)
                                completed += progressData[progress].completed;
                        }
                        //Start the notifier progress bar, if not started
                        if (total && !this._notifier.total(notificationId))
                            this._notifier.startProgress({ id: notificationId, status: 'Start progress' });
                        //Update the notifier total if it changed
                        if (this._notifier.total(notificationId) && this._notifier.total(notificationId) !== total)
                            this._notifier.updateTotal(notificationId, total);
                        this._notifier.progress({ status: `${logStr} processing: ${progressValues}`, id: notificationId });
                        console.log('progress', completed, this._notifier.total(notificationId));
                    }
                }
                else {
                    this._notifier.progress({ id: notificationId, message: event.message, status: `${logStr} processing items` });
                }
                break;
            default:
                this._notifier.progress({ id: notificationId, status: `${logStr}: ${event.status}`, message: event.message });
        }
        console.log('New Socket Event', {
            status: event.status,
            message: event.msg,
            data: event.data || null,
            error: event.error || null
        });
        this.status = event.status;
        this.message = event.message;
        this.data = (event.data) ? JSON.stringify(event.data) : null;
        this.error = event.error || null;
        this.currentBidder = event.bidder || null;
    }
    createPendingNotification() {
        if (this.pendingNotification.bidder && this.pendingNotification.user && this.pendingNotification.state
            && this.pendingNotification.dfpNetworkCode) {
            this._http.post('/lineitemautomationnotification', Object.assign({}, this.pendingNotification)).toPromise()
                .then(response => console.log('Notification created', response.json()))
                .catch(err => console.error('Unable to create notification', err));
        }
        else {
            this._talk.broadcast('Missing required values to create notification');
        }
    }
};
exports.TestLineItemAutomationComponent = TestLineItemAutomationComponent;
exports.TestLineItemAutomationComponent = TestLineItemAutomationComponent = __decorate([
    (0, core_1.Component)({
        selector: 'line-automation',
        template: `
      <div class="container" style="padding:10px">
          <div class="row">
              <h1> Test Line Item Automation Service</h1>
              <div class="col-md-6">
                  <div class="form-group">
                      <label>Bidder ID/s: </label>
                      <input class="form-control col-xs-6 col-md-6" [(ngModel)]="bidder" placeholder="Bidder Id or Ids separated by ,">
                  </div>
                  <div class="form-group">
                      <label>DFP Network Code: </label>
                      <input class="form-control col-xs-6 col-md-6" [(ngModel)]="TEST_DFP_NETWORK_ID" placeholder="DfpNetworkCode">
                  </div>
                  <div class="form-group">
                      <label for="companyId">Select Company ID:</label>
                      <select class="form-control col-xs-6 col-md-6" [(ngModel)]="companyId" name="companyId">
                          <hr>
                          <option *ngFor="let company of TEST_COMPANY_IDS" [value]="company">{{company}}</option>
                      </select>
                  </div>
                  <div class="form-group topMargin5">
                      <label for="naminConvIncr">Naming Convention Incrementor({{namingConventionIncrement}})</label>
                      <input class="form-control" step="1" type="range" min="1" max="20" name="naminConvIncr" [(ngModel)]="namingConventionIncrement">
                  </div>
                  <label class="checkbox-inline"><input type="checkbox" [(ngModel)]="bypassBidderStateVerification">Bypass Bidder State Verification Check</label>
              </div>
              <div class="col-md-6">
                  <button class="btn btn-large btn-primary topMargin5 col-xs-12 col-md-12" (click)="startRequest('single')">Start Single Request</button>
                  <button class="btn btn-large btn-primary topMargin5 col-xs-12 col-md-12" (click)="startRequest('multiple')">Start Multiple Requests</button>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12 col-xs-12 marginTop10">
                  <h4 *ngIf="currentBidder"><strong>Bidder:</strong> {{currentBidder}}</h4>
                  <h4 *ngIf="status"><strong>Status:</strong> {{status}}</h4>
                  <h4 *ngIf="message"><strong>Message:</strong> {{message}}</h4>
                  <div *ngIf="error">
                      <h4><strong>Error Trace:</strong> </h4>
                      {{error}}
                  </div>
                  <div *ngIf="data">
                      <h4><strong>Received Data:</strong> </h4>
                      {{data}}
                  </div>
                  <div *ngIf="args">
                      <h4><strong>Config Data Sent: </strong></h4>
                      <div style="max-width:600px;overflow-x:scroll">{{args}}</div>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-xs-12 col-md-12 marginTop10">
                  <h2>Create LIA notification</h2>
                  <input class="form-control" [(ngModel)]="pendingNotification.bidder" placeholder="Bidder Id..">
                  <input class="form-control" [(ngModel)]="pendingNotification.user" placeholder="User Id..">
                  <input class="form-control" [(ngModel)]="pendingNotification.dfpNetworkCode" placeholder="DfpNetworkCode..">
                  <input class="form-control" [(ngModel)]="pendingNotification.state" placeholder="State..">
                  <button class="btn btn-large btn-primary col-xs-12 col-md-12 topMargin5" (click)="createPendingNotification()">Create Pending Notification</button>
              </div>
          </div>
      </div>
	`,
    }),
    __metadata("design:paramtypes", [lineitem_automation_service_1.LineAutomationService,
        notification_service_1.NotificationService,
        notifier_service_1.NotifierService,
        token_service_1.TokenService])
], TestLineItemAutomationComponent);
//# sourceMappingURL=test-line-automation.component.js.map